exports.roles = {
  INSTRUCTOR: 'instructor',
  EDUCATOR: 'educator',
  LEARNER: 'learner',
  STUDENT: 'student',
};
